/** The unique name identifier for the main compound path being manipulated. */
export const TARGET_PATH_NAME = 'parentPath';

/** The unique name identifier for the group containing perpendicular lines and highlighted segments. */
export const PERPENDICULAR_LINE_GROUP_NAME = 'perpendicularLineGroup';

/** The tolerance radius used for hit testing points near paths. */
export const TOLERANCE = 300;
